import { render, staticRenderFns } from "./PurchaseSelectVendor.vue?vue&type=template&id=42997226&scoped=true&"
import script from "./PurchaseSelectVendor.vue?vue&type=script&lang=js&"
export * from "./PurchaseSelectVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42997226",
  null
  
)

export default component.exports